import { makeStyles, mergeClasses } from '../../styling';
import { createTokens } from '../../theme/fluent9';
import { getGutterValue } from '../gutters';
import { PaddingPropName, PaddingProps as UsePaddingProps } from '../padding';

import { ClassNameAndInlineStyles } from './types';

export type { UsePaddingProps };

const orderedPaddingPropNames: PaddingPropName[] = [
  'padding',
  'verticalPadding',
  'horizontalPadding',
  'paddingTop',
  'paddingRight',
  'paddingBottom',
  'paddingLeft',
];

const { tokens: paddingTokens, cssVariables: paddingCSSVariables } = createTokens(orderedPaddingPropNames, 'padding');

type UsePadding = (props: UsePaddingProps) => ClassNameAndInlineStyles;
export const usePadding: UsePadding = (props) => {
  const paddingClassNames = usePaddingClassNames();

  const providedPaddingProps: PaddingPropName[] = (Object.keys(props) as PaddingPropName[]).filter(
    (prop) => props[prop] != null
  );

  const className = mergeClasses(...providedPaddingProps.map((prop) => paddingClassNames[prop]));
  const inlineStyles = providedPaddingProps.reduce(
    (styles, prop) => ({
      ...styles,
      [paddingCSSVariables[prop]]: getGutterValue(props[prop] as number),
    }),
    {}
  );

  return {
    className,
    inlineStyles,
  };
};

const usePaddingClassNames = makeStyles<PaddingPropName>({
  padding: {
    paddingTop: paddingTokens.padding,
    paddingRight: paddingTokens.padding,
    paddingBottom: paddingTokens.padding,
    paddingLeft: paddingTokens.padding,
  },
  verticalPadding: {
    paddingTop: paddingTokens.verticalPadding,
    paddingBottom: paddingTokens.verticalPadding,
  },
  horizontalPadding: {
    paddingRight: paddingTokens.horizontalPadding,
    paddingLeft: paddingTokens.horizontalPadding,
  },
  paddingTop: { paddingTop: paddingTokens.paddingTop },
  paddingRight: { paddingRight: paddingTokens.paddingRight },
  paddingBottom: { paddingBottom: paddingTokens.paddingBottom },
  paddingLeft: { paddingLeft: paddingTokens.paddingLeft },
});
